<template>
  <li :class="[`${links-col}__link-item`, activeClass]">
    <router-link :to="item.url">
      <div :class="`${links-col}__link-icon`"><i class="fa" :class="item.icon"></i></div>
      <p :class="`${links-col}__link`">{{ item.title }}</p>
    </router-link>
  </li>
</template>

<script>
  export default {
    name: 'DashboardItem',
    props: {
      item: {
        type: Object,
      },
      classPrefix: {
        type: String,
        default: 'links-col',
      },
    },
    computed: {
      activeClass() {
        return this.item.url === this.$route.name ? 'active' : '';
      },
    },
  };
</script>
